import { render, staticRenderFns } from "./StoryListView.vue?vue&type=template&id=228b0196"
import script from "./StoryListView.vue?vue&type=script&lang=js"
export * from "./StoryListView.vue?vue&type=script&lang=js"
import style0 from "./StoryListView.vue?vue&type=style&index=0&id=228b0196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports